import { RenderComponentStrategy } from './render-component.strategy';

export class BasePlate extends RenderComponentStrategy {
	componentKey = 'Thrust_bearing';
}
